export default __webpack_public_path__ + "static/media/IsmailImg.15e61743.jpg";